import { onMounted, reactive } from '@vue/composition-api';
import dayjs from 'dayjs';
import { getServerTime } from '@/utils/date-helper';
import { cache } from '@tencent/ppd-base-libs';
import { myPromise } from '@/utils/promise-handler';

const STORAGE_KEY = 'upgradeDialogShowed';
const STORAGE_TIME = 1000 * 60 * 60 * 24 * 365 * 1;

/** 是否展示 */
const isShowed = () => cache.getItemSync(STORAGE_KEY);

/** 是否需要展示 */
const getIsNeedShow = () => (+dayjs(getServerTime()).format('YYYYMM') <= 202205) && !isShowed();

const promiseHandler = myPromise();
const showData = reactive({
  /** 弹窗展示状态 */
  isShow: false,
  /** 是否需要展示任务已刷新弹窗 */
  isNeedShow: getIsNeedShow(),
});

/**
 * 每月任务刷新弹窗展示hooks
 */
export const useUpgradeDialog = () => {
  onMounted(() => {
    showData.isNeedShow = getIsNeedShow();
  });
  const showDialog = async () => {
    cache.setItemSync(STORAGE_KEY, true, STORAGE_TIME);
    showData.isShow = true;
    showData.isNeedShow = getIsNeedShow();
    return promiseHandler.p;
  };
  const hideDialog = () => {
    showData.isShow = false;
    promiseHandler.res(true);
  };
  return {
    /** 弹窗展示数据 */
    showData,
    /** 展示弹窗 */
    showDialog,
    /** 关闭弹窗 */
    hideDialog,
  };
};
